import main from "../main";

function addLineListener() {
  removeLineListener();
  window.addEventListener("online", updateOnlineStatus);
  window.addEventListener("offline", updateOnlineStatus);
}

function removeLineListener() {
  window.removeEventListener("online", updateOnlineStatus);
  window.removeEventListener("offline", updateOnlineStatus);
}

function updateOnlineStatus(e) {
  const { store } = main.getVueMachine();

  const { type } = e;
  const onLine = type === "online";

  console.log(onLine, store.state.ws.isReconnect);
  if (onLine && store.state.ws.isReconnect) {
    // alert(this.isReconnect)
    window.location.reload();
  }
}

addLineListener();
